module.exports = require("didyoumean");


//////////////////
// WEBPACK FOOTER
// external "didyoumean"
// module id = 22
// module chunks = 0